import { App } from "antd"
import { useCallback } from "react";

export const useMessageHandler = () => {
  const { message, notification } = App.useApp();
  const handleMessage = useCallback(<T extends { message: unknown, ok?: boolean }>(data: T): T => {
    if (data instanceof Error) {
      message.error(data.message);
      return data;
    }
    if (!data.message) return data;
    const content = typeof data.message === 'string'
      ? data.message
      : JSON.stringify(data.message);
    if (data.ok) {
      message.success(content);
      return data;
    }
    notification.open({
      key: 'PERMISSION',
      type: 'error',
      description: content,
    });
    return data;
  }, []);
  return { handleMessage }
}
